import { z } from 'zod';

const inEnergyDetailsPriceCalculationSchema = z.object({
  expected_price_per_kwh: z.number(),
  purchasing_costs_per_kwh: z.number(),
  energy_tax_per_kwh: z.number(),
  expected_total_price_per_kwh: z.number(),
});

const outEnergyDetailsPriceCalculationSchema = z.object({
  expected_price_per_kwh_return: z.number(),
  purchasing_costs_per_kwh_return: z.number(),
  energy_tax_per_kwh_return: z.number(),
  expected_total_price_per_kwh_return: z.number(),
});

const energyDetailsPriceCalculationSchema = z.object({
  minimum_energy_usage: z.number(),
  maximum_energy_usage: z.number(),
  in_energy_details_price_calculation:
    inEnergyDetailsPriceCalculationSchema.nullable(),
  out_energy_details_price_calculation:
    outEnergyDetailsPriceCalculationSchema.nullable(),
});

const gasDetailsPriceCalculationSchema = z.object({
  minimum_gas_usage: z.number(),
  maximum_gas_usage: z.number(),
  price_per_m3: z.number(),
  costs_per_m3: z.number(),
  tax_per_m3: z.number(),
  total_price_per_m3: z.number(),
});

const energyPriceCalculationSchema = z.object({
  energy_details_price_calculations: z.array(
    energyDetailsPriceCalculationSchema,
  ),
  expected_yearly_costs: z.number(),
  expected_yearly_cost_usage: z.number(),
  expected_return: z.number(),
  annual_fixed_delivery_costs: z.number(),
  annual_grid_management_costs: z.number(),
  annual_energy_tax_reduction: z.number(),
});

const gasPriceCalculationSchema = z.object({
  gas_details_price_calculations: z.array(gasDetailsPriceCalculationSchema),
  expected_yearly_costs: z.number(),
  expected_yearly_cost_usage: z.number(),
  annual_fixed_delivery_costs: z.number(),
  annual_grid_management_costs: z.number(),
});

const totalPriceCalculationSchema = z.object({
  total_monthly_price_incl_vat: z.number(),
  total_yearly_price_incl_vat: z.number(),
});

export const contractPriceCalculationSchema = z.object({
  energy: energyPriceCalculationSchema.nullable(),
  gas: gasPriceCalculationSchema.nullable(),
  total: totalPriceCalculationSchema,
});

export type IInEnergyDetailsPriceCalculation = z.infer<
  typeof inEnergyDetailsPriceCalculationSchema
>;
export type IOutEnergyDetailsPriceCalculation = z.infer<
  typeof outEnergyDetailsPriceCalculationSchema
>;
export type IEnergyDetailsPriceCalculation = z.infer<
  typeof energyDetailsPriceCalculationSchema
>;
export type IGasDetailsPriceCalculation = z.infer<
  typeof gasDetailsPriceCalculationSchema
>;
export type IEnergyPriceCalculation = z.infer<
  typeof energyPriceCalculationSchema
>;
export type IGasPriceCalculation = z.infer<typeof gasPriceCalculationSchema>;
export type ITotalPriceCalculation = z.infer<
  typeof totalPriceCalculationSchema
>;
export type IContractPriceCalculation = z.infer<
  typeof contractPriceCalculationSchema
>;
